import React, { useState } from "react";
import QuestionDropDown from "../../../components/question-components/QuestionDropDown";
import "../../../styles/pages-styles/main-dashboard-pages-styles/knowledge-pages-styles/KnowledgeReview.css";
// import FeatureItem from "../../../components/knowledge-components/FeatureItem";
// import CategoriesPanel from "../../../components/knowledge-components/CategoriesPanel";


const KnowledgeReview = () => {
  const [sortOption, setSortOption] = useState("score");

  return (
    <div className="knowledge-review-container">
      <div className="knowledge-review-header">
        <h5>Review facts</h5>
        <p>
          Knowledge tutor questions are generated around core facts. You are
          able to review the facts you've previously been tested on here,
          including a summary of how well you understand these facts.
        </p>
      </div>

      <div className="Knowledge-review-body">
        <div className="knowledge-review-sidebar">
          <div className="knowledge-review-sort-options">
            <div className="knowledge-review-sort-option">
              <input
                type="radio"
                name="sortit"
                id="sort-date"
                checked={sortOption === "date"}
                onChange={() => setSortOption("date")}
              />
              <label htmlFor="sort-date">
                Sort by date of last attempt (most recent first)
              </label>
            </div>
            <div className="knowledge-review-sort-option">
              <input
                type="radio"
                name="sortit"
                id="sort-group"
                checked={sortOption === "group"}
                onChange={() => setSortOption("group")}
              />
              <label htmlFor="sort-group">Group by fact type</label>
            </div>
            <div className="knowledge-review-sort-option">
              <input
                type="radio"
                name="sortit"
                id="sort-relevance"
                checked={sortOption === "relevance"}
                onChange={() => setSortOption("relevance")}
              />
              <label htmlFor="sort-relevance">
                Sort by relevance (most relevant first)
              </label>
            </div>
            <div className="knowledge-review-sort-option">
              <input
                type="radio"
                name="sortit"
                id="sort-score"
                checked={sortOption === "score"}
                onChange={() => setSortOption("score")}
              />
              <label htmlFor="sort-score">
                Sort by score (worst score first)
              </label>
            </div>
          </div>

          {/* <CategoriesPanel /> */}

          <div className="knowledge-review-include-checkbox">
            <input type="checkbox" name="include" id="include-acceptable" />
            <label htmlFor="include-acceptable">
              Include facts where my recall is acceptable
            </label>
          </div>

          <div className="knowledge-review-high-yield">
            <p>High-yield rating:</p>
            <QuestionDropDown />
          </div>
        </div>

        <div className="knowledge-review-main-content">
          {/* {[
            "Addison's disease - hyperpigmentation of the palmar creases",
            "Immunisation schedule: 13-18 years immunisations: DT + IPV + Men ACWY",
            "Immunisation schedule: At birth immunisations: BCG if risk factors",
            "Immunisation schedule: 3-4 years immunisations: MMR + DTaP + IPV",
          ].map((title, index) => (
            <FeatureItem key={index} title={title} notes={0} totalNotes={1} />
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeReview;
